export default __webpack_public_path__ + "static/media/Resume.0cc1ab65.pdf";